// extracted by mini-css-extract-plugin
export default {"coverageDanger":"completion_rate_badge-module___coverageDanger___ca202b77","coverageSuccess":"completion_rate_badge-module___coverageSuccess___b9230e4b"};